import { usePutMutation } from "@/api/swr/useMutation";
import { companyUpdateSchema } from "@/schema/console/companies/CompanyUpdate";
import { z } from "zod";

type Config = Parameters<
  typeof usePutMutation<typeof companyUpdateSchema, z.ZodNull>
>[3];

export function useUpdateCompany(id: string, config: Config) {
  return usePutMutation(
    companyUpdateSchema,
    z.null(),
    `/console/companies/${id}`,
    config,
  );
}
